// extracted by mini-css-extract-plugin
export var container = "_ep-0";
export var content = "_ep-3";
export var customerTitle = "_ep-4";
export var empty = "_ep-5";
export var gray = "_ep-6";
export var header = "_ep-7";
export var info = "_ep-8";
export var loading = "_ep-2";
export var loadingCard = "_ep-9";
export var oneLine = "_ep-a";
export var personName = "_ep-e";
export var pillContainer = "_ep-b";
export var selected = "_ep-1";
export var text = "_ep-c";
export var twoLines = "_ep-d";
export var unread = "_ep-f";
export var unreadIndicator = "_ep-g";